
import Component from "vue-class-component";
import Vue from "vue";
import { SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { EditBillToManufacturerModel } from "@/models/ui/editBillToManufacturer";
import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
import { BillToManufacturerCodeResource } from "../../models/api/system/billToManufacturers";

const systemModuleState = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ImportTrucks extends Vue {
  billTo: string = null;
  manufacturerCode: string = null;
  loading: boolean = false;
  records: BillToManufacturerCodeResource[] = null;
  editId: number = null;
  editModel: EditBillToManufacturerModel = null;

  async loadData() {
    this.loading = true;
    try {
      this.records = await systemModuleState.getBillToManufacturerCodes({
        billTo: this.billTo,
        code: this.manufacturerCode
      });
    } catch (ex) {
      notifications.error("Search Failed", "Failed to load records", ex);
    }
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  goBack() {
    this.$router.back();
  }

  async filter() {
    await this.loadData();
  }

  editRecord(record: BillToManufacturerCodeResource = null) {
    const model = new EditBillToManufacturerModel();

    if (record) {
      model.id = record.id;
      model.manufacturerCode = record.manufacturerCode;
      model.billTo = record.billTo;
    }

    this.editModel = model;
  }

  closeEditModal() {
    this.editModel.visible = false;
    this.editModel = null;
  }

  async saveRecord() {
    try {
      this.editModel.saving = true;
      if (this.editModel.isNew) {
        await systemModuleState.createBillToManufacturerCode(this.editModel.toCreateRequest());
      } else {
        await systemModuleState.updateBillToManufacturerCode(this.editModel.toUpdateRequest());
      }
      await this.loadData();
      this.editModel.visible = false;
      this.editModel = null;
      notifications.success("Save Success", "Record successfully saved");
    } catch (ex) {
      this.editModel.saving = false;
      notifications.error("Save Failed", "Failed to save record", ex);
    }
  }

  async deleteRecord(record: BillToManufacturerCodeResource) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await systemModuleState.deleteBillToManufacturerCode(record.id);
        await this.loadData();
        notifications.success("Delete Bill To Commodity", "Record successfully deleted.");
      } catch (ex) {
        notifications.error("Delete Bill To Commodity", "Failed to delete record", ex);
      }
    }
  }

  get canFilter() {
    return this.manufacturerCode || this.billTo;
  }
}
